define.alias("shared/components/shared/plan-recommendation/steps/profiles", "preview-grid/components/shared/plan-recommendation/steps/profiles");